import React, { useEffect, useImperativeHandle } from 'react'
import Styles from './IFRefreshComponent.module.css'
import Colors from 'Theme/Colors'
import RefreshIcon from '@mui/icons-material/Refresh'
import { useTranslation } from 'react-i18next'
import IFText from 'Components/IFText/IFText'
import moment from 'moment'
import IFSkeleton from 'Components/IFSkeleton/IFSkeleton'

const IFRefreshComponent = React.forwardRef(({ graphRef }, ref) => {
  const { t } = useTranslation()

  const [loading, setLoading] = React.useState(false)

  const setLoadingState = (bool) => {
    setLoading(bool)
  }

  useImperativeHandle(ref, () => ({
    setLoadingState,
  }))

  return (
    <div className={Styles.RefreshIconTextContainer}>
      {loading ? (
        <div className={Styles.RefreshIconTextContainer}>
          <div>
            <IFSkeleton
              height="1.5rem"
              className={Styles.RefreshTextSkeleton}
            />
            <IFSkeleton
              height="1.25rem"
              className={Styles.RefreshTextDateSkeleton}
            />
          </div>
          <div
            className={Styles.RefreshIcon}
            style={{ marginBottom: '0.5rem' }}
          >
            <IFSkeleton width="1.5rem" height="1.5rem" variant="circular" />
          </div>
        </div>
      ) : (
        <div className={Styles.RefreshIconTextContainer}>
          <div className={Styles.RefreshTextContainer}>
            <IFText
              className={Styles.RefreshText}
              style={{ color: Colors.black }}
            >
              {t('ChargePointDetails.lastUpdated')}
            </IFText>
            <IFText className={Styles.RefreshTextDate}>
              {moment(Date.now()).format('MMM DD, YYYY HH:mm:ss')}
            </IFText>
          </div>
          <div
            className={Styles.RefreshIcon}
            onClick={() => {
              graphRef?.current?.fetchHandler()
              setLoading(true)
            }}
          >
            <RefreshIcon
              sx={{ height: '1.25rem' }}
              className={Styles.refreshStart}
            />
          </div>
        </div>
      )}
    </div>
  )
})

function shouldSkipRender(prevProps, nextProps) {
  return true
}

export default React.memo(IFRefreshComponent, shouldSkipRender)
